import React from "react";
import { Inter, Space_Grotesk } from "next/font/google";
import "../styles/globals.css";
import "../components/common/Header.css";
import Head from "next/head";

import type { AppProps } from "next/app";
import { ThemeProvider } from "../context/ThemeContext";
import { ModalProvider } from "../components/common/Modal/ModalContext";

// Fontes fora do componente para evitar recriação
const inter = Inter({ subsets: ["latin"], variable: "--font-inter" });
const spaceGrotesk = Space_Grotesk({
  subsets: ["latin"],
  variable: "--font-space-grotesk",
});

const AppWithTheme = React.memo(function AppWithTheme({
  Component,
  pageProps,
}: AppProps) {
  return (
    <>
      <Head>
        <title>Ingressos Caledonia</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <Component {...pageProps} />
    </>
  );
});

function MyApp(props: AppProps) {
  return (
    <div className={`${inter.variable} ${spaceGrotesk.variable}`}>
      <ThemeProvider>
        <ModalProvider>
          <AppWithTheme {...props} />
        </ModalProvider>
      </ThemeProvider>
    </div>
  );
}

export default MyApp;
  